







import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Component
export default class CartSignUpDefaultFormNote extends Vue {
  @Prop({ required: true })
  hostName: string
}
